import Script from "next/script";
import React from "react";

interface InjectQueryParamProps {
  id: string;
  paramKey: string;
  paramValue: string;
}

export const InjectQueryParam: React.FC<InjectQueryParamProps> = ({ id, paramKey, paramValue }) => {
  return (
    <Script id={id}>
      {`(function () {
        if (typeof window === "undefined") return;
        const url = new URL(window.location.href);
        if (!url.searchParams.has("${paramKey}")) {
          url.searchParams.set("${paramKey}", "${paramValue}");
          window.history.replaceState(null, "", url.toString());
        }
      })();`}
    </Script>
  );
};
